import PopupHideToday from '../../../component/common/popup/PopupHideToday';

const BoardNotice_popup = () => {

    return (
        <div className='w-screen h-screen popup_font'>
            <div className=' flex flex-col pl-1'>
                <div className='bg_ho_primary p-2 flex'>
                    <h3 className='co_white content-center'>업무공유 안내</h3>
                </div>
                <div className='flex flex-col p-5 gap-5'>
                    <h5>궁금한 답변 쪽집게처럼 얻는 팁(표준등록체계 기준)</h5>
                    <div className='flex flex-col gap-3'>
                        <p className='co_blue bold'>1. FAQ : 검색창(제목+내용)에서 검색하기</p>
                        <p>2. 오류, 재검토: 내원일시, 의무기록번호 등 포함해서 질의하기</p>
                        <p>3. 인트라넷 메뉴 구분해서 질의하기: 오류내역 관리, 충실도 정보관리 등</p>
                        <p>4. 게시글분류 선택하여 질의하기<br/>&emsp;예) 권역외상센터, 표준등록체계(입력) 분리해서 각각 질의</p>
                        <p>5. 동일기관, 분류(게시글분류)가 같은 경우 질문을 한번에 정리해서 등록하기<br/>&emsp;→ 질문 수정 시에는 ‘댓글’로 추가 질의하기</p>
                    </div>
                </div>
                <div className='p-5'>
                    <PopupHideToday popupId='board' />
                </div>
            </div>
        </div>
    )
};

export default BoardNotice_popup;